import dynamic from 'next/dynamic';

import { Skeleton } from '@ordering/components/ui/skeleton';

import type { MapProps } from './MapClient';
export type { MapProps } from './MapClient';

export const Map = dynamic<MapProps>(() => import('./MapClient').then((module) => module.MapClient), {
  ssr: false,
  loading: () => <Skeleton className="h-[220px] w-full rounded-lg" />,
});
